import React, { useEffect, useRef, useState } from 'react';
import { BrowserMultiFormatReader } from '@zxing/library';
import '../styles/BarcodeScanner.css';

const BarcodeScannerComponent = () => {
  const [barcodeValue, setBarcodeValue] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const videoRef = useRef(null);

  useEffect(() => {
    const codeReader = new BrowserMultiFormatReader();
    let activeStream;

    const initializeScanner = async () => {
      try {
        console.log('Initializing scanner...');
        const stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: 'environment' },
        });

        activeStream = stream;

        if (videoRef.current) {
          videoRef.current.srcObject = stream;
        }

        // Start barcode scanning
        codeReader.decodeFromVideoDevice(null, videoRef.current, (result, error) => {
          if (result) {
            const videoElement = videoRef.current;

            // Get video dimensions
            const videoWidth = videoElement.videoWidth;
            const videoHeight = videoElement.videoHeight;

            // Define scanning box dimensions (centered rectangle)
            const scanningBox = {
              x: videoWidth * 0.1, // 10% from the left
              y: videoHeight * 0.4, // 40% from the top
              width: videoWidth * 0.8, // 80% of the width
              height: videoHeight * 0.2, // 20% of the height
            };

            // Get the positions of the detected barcode
            const resultPoints = result.resultPoints;

            // Check if all points are inside the scanning box
            const isInsideBox = resultPoints.every(
              (point) =>
                point.x >= scanningBox.x &&
                point.x <= scanningBox.x + scanningBox.width &&
                point.y >= scanningBox.y &&
                point.y <= scanningBox.y + scanningBox.height
            );

            if (isInsideBox) {
              console.log('Barcode detected inside box:', result.getText());
              setBarcodeValue(result.getText()); // Update the scanned barcode
            } else {
              console.log('Barcode detected outside box. Ignored.');
            }
          }

          // if (error) {
          //   console.error('Scanning error:', error);
          //   setErrorMessage('Scanning error. Please try again.');
          // }
        });
      } catch (error) {
        console.error('Error initializing scanner:', error);
        setErrorMessage('Failed to access the camera. Please check your permissions.');
      }
    };

    initializeScanner();

    return () => {
      if (activeStream) {
        activeStream.getTracks().forEach((track) => track.stop());
      }
      codeReader.reset();
    };
  }, []);

  return (
    <div className="scanner-page">
      <h1 className="scanner-title">Barcode Scanner</h1>
      <div className="scanner-container">
        <video ref={videoRef} className="scanner-video" autoPlay playsInline></video>
        <div className="scanner-overlay">
          <p className="scanner-instructions">Mantén el código de barras dentro del marco para escanearlo</p>
          <div className="scanner-box"></div>
        </div>
      </div>
      {barcodeValue && (
        <p className="scanner-output">
          <strong>Scanned Barcode:</strong> {barcodeValue}
        </p>
      )}
      {errorMessage && <p className="scanner-error">{errorMessage}</p>}
    </div>
  );
};

export default BarcodeScannerComponent;
